import { Component } from '@angular/core';
import { RouterLink, Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink, CommonModule],
  template: `
    <footer class="footer-elegant" id="contacto">
      <div class="footer-top-decoration"></div>
      <div class="container">
        <div class="footer-content-elegant">
          <!-- Column 1: Brand -->
          <div class="footer-column footer-brand-column">
            <div class="footer-logo-wrapper">
              <img [src]="logoPath" [alt]="hotelName + ' Logo'" class="footer-logo-elegant">
            </div>
            <h5 class="footer-brand-title">{{ hotelName }}</h5>
            <p class="footer-tagline-elegant">Casa del Sol Dorado</p>
            <p class="footer-description-elegant">
              Experiencia hotelera única en el corazón de Sarhua, donde la tradición andina se encuentra con el confort
              moderno.
            </p>
          </div>

          <!-- Column 2: Quick Links -->
          <div class="footer-column">
            <h6 class="footer-title-elegant">Enlaces Rápidos</h6>
            <ul class="footer-links-elegant">
              <li>
                <a [routerLink]="['/']" fragment="home" class="footer-link-elegant">
                  <svg viewBox="0 0 24 24" fill="none" width="14" height="14">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  Inicio
                </a>
              </li>
              <li>
                <a [routerLink]="['/']" fragment="sobre-nosotros" class="footer-link-elegant">
                  <svg viewBox="0 0 24 24" fill="none" width="14" height="14">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  Sobre Nosotros
                </a>
              </li>
              <li>
                <a [routerLink]="['/']" fragment="habitaciones" class="footer-link-elegant">
                  <svg viewBox="0 0 24 24" fill="none" width="14" height="14">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  Habitaciones
                </a>
              </li>
              <li>
                <a [routerLink]="['/tienda']" class="footer-link-elegant">
                  <svg viewBox="0 0 24 24" fill="none" width="14" height="14">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  Artesanías
                </a>
              </li>
              <li>
                <a [routerLink]="['/']" fragment="caracteristicas" class="footer-link-elegant">
                  <svg viewBox="0 0 24 24" fill="none" width="14" height="14">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  Servicios
                </a>
              </li>
              <li>
                <a [routerLink]="['/auth/login']" class="footer-link-elegant">
                  <svg viewBox="0 0 24 24" fill="none" width="14" height="14">
                    <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  Iniciar Sesión
                </a>
              </li>
            </ul>
          </div>

          <!-- Column 3: Contact Info -->
          <div class="footer-column">
            <h6 class="footer-title-elegant">Contacto</h6>
            <ul class="footer-contact-elegant">
              <li class="footer-contact-item-elegant">
                <div class="contact-icon-elegant">
                  <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
                    <rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" stroke-width="1.5" />
                    <path d="M2 7L12 13L22 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                  </svg>
                </div>
                <div class="contact-text-elegant">
                  <span class="contact-label-elegant">Email</span>
                  <span class="contact-value-elegant">central&#64;sunturquriwasi.com</span>
                </div>
              </li>
              <li class="footer-contact-item-elegant">
                <div class="contact-icon-elegant">
                  <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
                    <path d="M22 16.92V19.92C22 20.48 21.56 20.93 21 20.97C20.83 20.99 20.66 21 20.5 21C10.84 21 3 13.16 3 3.5C3 3.34 3.01 3.17 3.03 3C3.07 2.44 3.52 2 4.08 2H7.08C7.57 2 7.99 2.36 8.07 2.84C8.14 3.27 8.26 3.69 8.41 4.09C8.56 4.51 8.45 4.98 8.12 5.29L6.59 6.82C8.27 9.92 10.93 12.58 14.03 14.26L15.56 12.73C15.87 12.4 16.34 12.29 16.76 12.44C17.16 12.59 17.58 12.71 18.01 12.78C18.49 12.86 18.85 13.28 18.85 13.77V16.92H22Z" stroke="currentColor" stroke-width="1.5" />
                  </svg>
                </div>
                <div class="contact-text-elegant">
                  <span class="contact-label-elegant">Teléfono</span>
                  <span class="contact-value-elegant">+51 969 028 731</span>
                </div>
              </li>
              <li class="footer-contact-item-elegant">
                <div class="contact-icon-elegant">
                  <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
                    <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2Z" stroke="currentColor" stroke-width="1.5" />
                    <circle cx="12" cy="9" r="2.5" stroke="currentColor" stroke-width="1.5" />
                  </svg>
                </div>
                <div class="contact-text-elegant">
                  <span class="contact-label-elegant">Ubicación</span>
                  <span class="contact-value-elegant">Sarhua, Ayacucho, Perú</span>
                </div>
              </li>
            </ul>
          </div>

          <!-- Column 4: Social -->
          <div class="footer-column">
            <h6 class="footer-title-elegant">Síguenos</h6>
            <div class="footer-social-elegant">
              <a href="https://www.facebook.com/profile.php?id=61583601364897" target="_blank" class="social-link-elegant" aria-label="Facebook">
                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                  <path d="M18 2H15C13.6739 2 12.4021 2.52678 11.4645 3.46447C10.5268 4.40215 10 5.67392 10 7V10H7V14H10V22H14V14H17L18 10H14V7C14 6.73478 14.1054 6.48043 14.2929 6.29289C14.4804 6.10536 14.7348 6 15 6H18V2Z" />
                </svg>
              </a>
              <a href="https://www.instagram.com/sunturquriwasi?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" class="social-link-elegant" aria-label="Instagram">
                <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
                  <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" stroke-width="1.5" />
                  <circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="1.5" />
                  <circle cx="18" cy="6" r="1.5" fill="currentColor" />
                </svg>
              </a>
              <a href="https://wa.me/51969028731?text=Hola%2C%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n%20sobre%20Suntur%20Quri%20Wasi" target="_blank" class="social-link-elegant social-whatsapp" aria-label="WhatsApp">
                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div class="footer-divider-elegant"></div>

        <div class="footer-bottom-elegant">
          <p class="footer-copyright-elegant">
            &copy; {{ currentYear }} <strong>{{ hotelName }}</strong>. Todos los derechos reservados.
          </p>
          <div class="footer-bottom-links-elegant">
            <a [routerLink]="['/politica-de-privacidad']" class="footer-bottom-link-elegant">Política de Privacidad</a>
            <span class="separator-elegant"></span>
            <a [routerLink]="['/terminos-y-condiciones']" class="footer-bottom-link-elegant">Términos y Condiciones</a>
            
            <a [routerLink]="['/libro-reclamaciones']" class="claims-book-btn-elegant">
              <div class="claims-book-icon-wrapper">
                <svg viewBox="0 0 24 24" fill="none" width="24" height="24">
                  <path d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2V2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16 2V22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 7H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 11H13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="claims-book-text-elegant">
                <span class="subtitle">Libro de</span>
                <strong class="title">RECLAMACIONES</strong>
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  `,
  styles: [`
    .footer-elegant {
        position: relative;
        background: linear-gradient(160deg, #5d4037 0%, #4e342e 50%, #3e2723 100%);
        color: #f5f0e8;
        padding: 5rem 0 2rem;
        overflow: hidden;
    }

    .footer-top-decoration {
        position: absolute;
        top: 0; left: 0; right: 0;
        height: 4px;
        background: linear-gradient(90deg, #C86A4A 0%, #A47551 50%, #C86A4A 100%);
    }

    .footer-content-elegant {
        display: grid;
        grid-template-columns: 1.3fr 1fr 1.2fr 1.2fr;
        gap: 2rem;
        margin-bottom: 2rem;
    }

    .footer-column { display: flex; flex-direction: column; }
    .footer-brand-column { padding-right: 1.5rem; }

    .footer-logo-wrapper {
        width: 80px; height: 80px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 12px;
        display: flex; align-items: center; justify-content: center;
        margin-bottom: 1rem;
        border: 1px solid rgba(255, 255, 255, 0.1);
    }

    .footer-logo-elegant { max-width: 60px; height: auto; filter: brightness(1.2); }

    .footer-brand-title {
        font-family: inherit; font-size: 20px; color: white;
        margin-bottom: 4px; font-weight: 600; letter-spacing: 1px;
    }

    .footer-tagline-elegant {
        font-size: 14px; color: #d7ccc8; font-style: italic; margin-bottom: 1rem;
    }

    .footer-description-elegant {
        font-size: 14px; line-height: 1.7; color: rgba(255, 255, 255, 0.7);
    }

    .footer-title-elegant {
        font-size: 16px; color: white; margin-bottom: 1.5rem;
        font-weight: 600; text-transform: uppercase; letter-spacing: 2px;
        position: relative; padding-bottom: 0.5rem;
    }

    .footer-title-elegant::after {
        content: ''; position: absolute; bottom: 0; left: 0;
        width: 30px; height: 2px; background: #C86A4A;
    }

    .footer-links-elegant { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 0.5rem; }

    .footer-link-elegant {
        display: inline-flex; align-items: center; gap: 0.5rem;
        font-size: 14px; color: rgba(255, 255, 255, 0.7);
        text-decoration: none; cursor: pointer; transition: all 0.3s ease;
    }

    .footer-link-elegant svg { opacity: 0; transform: translateX(-5px); transition: all 0.3s ease; color: #d7ccc8; }
    .footer-link-elegant:hover { color: white; transform: translateX(5px); }
    .footer-link-elegant:hover svg { opacity: 1; transform: translateX(0); }

    .footer-contact-elegant { list-style: none; padding: 0; margin: 0; display: flex; flex-direction: column; gap: 1rem; }
    .footer-contact-item-elegant { display: flex; align-items: flex-start; gap: 1rem; }

    .contact-icon-elegant {
        width: 36px; height: 36px; background: rgba(200, 106, 74, 0.2);
        border-radius: 8px; display: flex; align-items: center; justify-content: center;
        flex-shrink: 0; transition: all 0.3s ease;
    }
    .contact-icon-elegant svg { color: #d7ccc8; }
    .footer-contact-item-elegant:hover .contact-icon-elegant { background: #C86A4A; }
    .footer-contact-item-elegant:hover .contact-icon-elegant svg { color: white; }

    .contact-text-elegant { display: flex; flex-direction: column; gap: 2px; }
    .contact-label-elegant { font-size: 10px; color: rgba(255, 255, 255, 0.5); text-transform: uppercase; letter-spacing: 1px; }
    .contact-value-elegant { font-size: 14px; color: rgba(255, 255, 255, 0.9); }

    .footer-social-elegant { display: flex; gap: 0.75rem; }

    .social-link-elegant {
        width: 40px; height: 40px; background: rgba(255, 255, 255, 0.08);
        border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 8px;
        display: flex; align-items: center; justify-content: center;
        color: rgba(255, 255, 255, 0.7); text-decoration: none; transition: all 0.3s ease;
    }
    .social-link-elegant:hover { background: #C86A4A; color: white; transform: translateY(-3px); }

    .footer-divider-elegant {
        height: 1px; background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.1) 50%, transparent 100%);
        margin: 2rem 0;
    }

    .footer-bottom-elegant {
        display: flex; justify-content: space-between; align-items: center;
        flex-wrap: wrap; gap: 1rem;
    }

    .footer-copyright-elegant { font-size: 13px; color: rgba(255, 255, 255, 0.5); margin: 0; }
    .footer-copyright-elegant strong { color: rgba(255, 255, 255, 0.8); }

    .footer-bottom-links-elegant { display: flex; align-items: center; gap: 1rem; }
    .footer-bottom-link-elegant { font-size: 13px; color: rgba(255, 255, 255, 0.5); text-decoration: none; }
    .separator-elegant { width: 4px; height: 4px; background: rgba(255, 255, 255, 0.2); border-radius: 50%; }

    .claims-book-btn-elegant {
        display: inline-flex;
        align-items: center;
        gap: 12px;
        background: rgba(255, 255, 255, 0.05);
        border: 1px solid rgba(255, 255, 255, 0.1);
        padding: 10px 16px;
        border-radius: 10px;
        text-decoration: none;
        transition: all 0.3s ease;
        margin-left: 15px;
    }

    .claims-book-btn-elegant:hover {
        background: rgba(200, 106, 74, 0.15);
        border-color: #C86A4A;
        transform: translateY(-3px);
        box-shadow: 0 4px 12px rgba(200, 106, 74, 0.2);
    }

    .claims-book-icon-wrapper {
        display: flex;
        align-items: center;
        color: #C86A4A;
        background: rgba(255, 255, 255, 0.1);
        padding: 8px;
        border-radius: 8px;
        transition: all 0.3s ease;
    }

    .claims-book-btn-elegant:hover .claims-book-icon-wrapper {
        background: #C86A4A;
        color: white;
    }

    .claims-book-text-elegant {
        display: flex;
        flex-direction: column;
        line-height: 1.1;
    }

    .claims-book-text-elegant .subtitle {
        font-size: 10px;
        color: rgba(255, 255, 255, 0.6);
        text-transform: uppercase;
        letter-spacing: 1px;
    }

    .claims-book-text-elegant .title {
        font-size: 14px;
        color: #f5f0e8;
        font-weight: 600;
        letter-spacing: 0.5px;
    }

    @media (max-width: 992px) {
        .footer-content-elegant { grid-template-columns: 1fr 1fr; }
    }
    @media (max-width: 768px) {
        .footer-content-elegant { grid-template-columns: 1fr; text-align: center; }
        .footer-logo-wrapper { margin-left: auto; margin-right: auto; }
        .footer-title-elegant::after { left: 50%; transform: translateX(-50%); }
        .footer-links-elegant, .footer-contact-elegant, .footer-social-elegant { align-items: center; justify-content: center; }
        .footer-contact-item-elegant { flex-direction: column; align-items: center; }
        .footer-bottom-elegant { flex-direction: column; }
    }

    .container { width: 100%; max-width: 1200px; margin: 0 auto; padding: 0 1rem; }
  `]
})
export class FooterComponent {
  hotelName = 'SUNTUR QURI WASI';
  currentYear = new Date().getFullYear();
  logoPath = '/logos/logo_final.png';
}
